import { render } from "./ShippingRates.vue?vue&type=template&id=732fd87a&scoped=true"
import script from "./ShippingRates.vue?vue&type=script&lang=js"
export * from "./ShippingRates.vue?vue&type=script&lang=js"

import "./ShippingRates.vue?vue&type=style&index=0&id=732fd87a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732fd87a"]])

export default __exports__